/*  ========================================================================
    # Scripts - Header
    ========================================================================  */

const Header = {
  config: {
    mobileMenuButton: document.querySelector('.c-header__mobile-menu-button'),
    mobileCloseButton: document.querySelector('.c-mobile-menu__back-button'),
    mobileMenu: document.querySelector('.c-mobile-menu'),
    mobileMenuMenu: document.querySelector('.c-mobile-menu__menu'),
    mobileTicketButtonContainer: document.querySelector('.c-mobile-menu__ticket-container'),
    body: document.querySelector('body'),
    menuItems: document.querySelectorAll('.menu-item'),
    mobileSocialIcons: document.querySelector('.c-mobile-menu__social')
  },

  initHeader() {
    this.config.mobileMenuButton.addEventListener('click', () => {
      this.config.mobileMenu.classList.add('c-mobile-menu-open');
      this.config.mobileMenu.classList.add('c-mobile-menu-active');

      // pop menu entries one after another
      this.config.mobileMenuMenu.classList.add('c-mobile-menu__menu-active');

      // ticket button
      this.config.mobileTicketButtonContainer.classList.add(
        'c-mobile-menu__ticket-container-active'
      );

      this.config.mobileSocialIcons.classList.add('c-mobile-menu__social-active');

      // body mobile menu opened
      this.config.body.classList.add('mobile-menu-opened');
    });

    this.config.mobileCloseButton.addEventListener('click', () => {
      this.resetMobileMenu();
    });

    this.config.menuItems.forEach(element => {
      element.addEventListener('click', () => {
        this.resetMobileMenu();
      });
    });
  },

  resetMobileMenu() {
    // reset all animations
    this.config.mobileMenu.classList.remove('c-mobile-menu-active');
    setTimeout(() => {
      this.config.mobileMenu.classList.remove('c-mobile-menu-open');
    }, 250);

    this.config.mobileTicketButtonContainer.classList.remove(
      'c-mobile-menu__ticket-container-active'
    );
    this.config.mobileMenuMenu.classList.remove('c-mobile-menu__menu-active');
    this.config.body.classList.remove('mobile-menu-opened');
    this.config.mobileSocialIcons.classList.remove('c-mobile-menu__social-active');
  },

  init() {
    this.initHeader();
  }
};

export default Header;
